import requiredFieldConfigRaw from '../../data/requiredFieldConfig';
import DisclosurePageRenderer from './DisclosurePageRenderer';

const SendDisclosures = () => {
    const config = requiredFieldConfigRaw.Pages.find(
        (p) => p.Page === 'Send Disclosures'
    );
    return (
        <DisclosurePageRenderer
            pageName="Send Disclosures"
            config={config}
            redirectPage="Send Disclosures"
        />
    );
};

export default SendDisclosures;
